<ng-template #template>
  <div class="context-menu" cdkMenu>
    @if (index !== 0) {
      <button
        cdkMenuItem
        mat-menu-item
        class="context-menu-item"
        type="button"
        (click)="emitMove('up')"
      >
        Move Up
      </button>
    }
    @if (index !== total - 1) {
      <button
        cdkMenuItem
        mat-menu-item
        class="context-menu-item"
        type="button"
        (click)="emitMove('down')"
      >
        Move Down
      </button>
    }
    @if (index !== 0) {
      <button
        cdkMenuItem
        mat-menu-item
        class="context-menu-item"
        type="button"
        (click)="emitMove('start')"
      >
        Move to Top
      </button>
    }
    @if (index !== total - 1) {
      <button
        cdkMenuItem
        mat-menu-item
        class="context-menu-item"
        type="button"
        (click)="emitMove('end')"
      >
        Move to Bottom
      </button>
    }
    @if (showRemove) {
      <mat-divider></mat-divider>
      <button
        cdkMenuItem
        mat-menu-item
        class="context-menu-item"
        type="button"
        (click)="emitRemove()"
      >
        {{ removeLabel }}
      </button>
    }
  </div>
</ng-template>
